
export function waitForElm<T extends HTMLElement>(selector: string): Promise<NodeListOf<T>> {
    return new Promise(resolve => {
        if (document.querySelectorAll(selector).length > 0) {
            return resolve(document.querySelectorAll(selector));
        }

        const observer = new MutationObserver(_mutations => {
            if (document.querySelectorAll(selector).length > 0) {
                observer.disconnect();
                resolve(document.querySelectorAll(selector));
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}